export class InferenceNode {
  constructor(displayName, value = null, options = {}) {
    this.displayName = displayName;
    this.value = value;
    this.css = options.css || {};
    this.children = options.children || [];
    this.defaultOpen = options.defaultOpen ?? true;
    this.escapeValue = options.escapeValue ?? true;
    this.path = options.path || null;
  }

  isValid() {
    return this.children.length > 0 || this.value !== null;
  }

  static from_json(obj) {
    return new InferenceNode(obj.displayName, obj.value, {
      css: obj.css,
      children: obj.children.map(child => this.from_json(child)),
      defaultOpen: obj.defaultOpen,
      escapeValue: obj.escapeValue,
      path: obj.path,
    });
  }
}
